import { render } from "./WhatsAppModalSidebarRightChatMessageContainerMessages.vue?vue&type=template&id=b9d34688&scoped=true"
import script from "./WhatsAppModalSidebarRightChatMessageContainerMessages.vue?vue&type=script&lang=js"
export * from "./WhatsAppModalSidebarRightChatMessageContainerMessages.vue?vue&type=script&lang=js"

import "./WhatsAppModalSidebarRightChatMessageContainerMessages.vue?vue&type=style&index=0&id=b9d34688&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9d34688"]])

export default __exports__